<template>
    <RunningTotalMobile></RunningTotalMobile>
    <LanguageSwitcher></LanguageSwitcher>
    <div class="booking-page-indicator" :data-page="getProgressStep" id="appTop">
        <ul class="indicator-pages">
            <li class="indicator-page " :class="{ active: isActive('/') }"  data-page="0">
                <router-link to="/">{{ $t("Accommodation & Dates") }}</router-link>
            </li>
            <li class="indicator-page" :class="{ active: isActive('/guest-details')||isActive('/vehicles') }"  data-page="1">
                <router-link :to="{ path: (getProgressStep<=0)?'':'/guest-details'}" :class="{ isDisabled: getProgressStep<=0 }">
                    {{ $t("Guest Details") }}
                </router-link>
            </li>
            <li class="indicator-page " :class="{ active: isActive('/extras') }"  data-page="2">
                <router-link :to="{ path: (getProgressStep<=1)?'':'/extras'}" :class="{ isDisabled: getProgressStep<=1 }">
                    {{ $t("Extras") }}
                </router-link>
            </li>
            <li class="indicator-page " :class="{ active: isActive('/travel-and-insurance') }"  data-page="3">
                <router-link :to="{ path: (getProgressStep<=2)?'':'/travel-and-insurance'}" :class="{ isDisabled: getProgressStep<=2 }">
                    {{ $t("Travel & insurance") }}
                </router-link>
            </li>
            <li class="indicator-page " :class="{ active: isActive('/discounts-and-offers') }"  data-page="4">
                <router-link :to="{ path: (getProgressStep<=3)?'':'/discounts-and-offers'}" :class="{ isDisabled: getProgressStep<=3 }">
                    {{ $t("Discounts & Offers") }}
                </router-link>
            </li>
            <li class="indicator-page " :class="{ active: isActive('/summary-and-confirmation') }"  data-page="5">
                <router-link :to="{ path: (getProgressStep<=4)?'':'/summary-and-confirmation'}" :class="{ isDisabled: getProgressStep<=4 }">
                    {{ $t("Summary And Confirmation") }}
                </router-link>
            </li>
        </ul>
        <div class="indicator">
            <div class="indicator-meter" :style="{ width: (getProgressStep*2+1)*100/12 + '%' }"></div>
        </div>
    </div>

    <div class="booking-pages">
        <!-- Booking Breakdown -->
        <div class="booking-breakdown active">
            <RunningTotal></RunningTotal>
            <!-- running total -->
        </div><!-- Page 1 - Guest Details -->
        <div class="booking-page" :data-page="getProgressStep">
            <router-view />
        </div><!-- Page 6 - Booked -->
        
    </div>
    

    
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios'

import RunningTotal from "./components/RunningTotal";
import RunningTotalMobile from "./components/RunningTotalMobile";
import LanguageSwitcher from "./components/LanguageSwitcher";
export default {
    components: {
        RunningTotal,
        RunningTotalMobile,
        LanguageSwitcher
    },
    created () {
        axios.post(process.env.VUE_APP_ROOT_URL+`booking/get-dates`)
            .then(response => {
              let loadedDates2=response.data;
              this.$store.commit('UPDATE_DATES',loadedDates2);
            })
            .catch(e => {
            //    this.errors.push(e)
               console.log(e);
            });
        axios.post(process.env.VUE_APP_ROOT_URL+`booking/get-countries`)
            .then(response => {
              this.$store.commit('UPDATE_COUNTRIES',response.data);
            })
            .catch(e => {
            //    this.errors.push(e)
               console.log(e);
            });
        axios.post(process.env.VUE_APP_ROOT_URL+`booking/get-enquiry-sources`)
            .then(response => {
                let loadedEnquirySources2=response.data;
                // console.log(response,loadedEnquirySources2);
              this.$store.commit('UPDATE_ENQUIRY_SOURCES',loadedEnquirySources2);
            })
            .catch(e => {
            //    this.errors.push(e)
               console.log(e);
            })
    },
    computed: {
        ...mapGetters([
            'getProgressStep',
        ]),        
    },
    methods: {
        isActive(url) {
            return url==this.$route.path;
        }
    },
};
</script>

<style>
    .swal2-container {
        font-family:Hansom,sans-serif;
        color: #00b8d3;
        /* cancelButtonColor:#ff7674; */
    }
    .continue_button {
        margin-top: 25px;
    }
    @media (max-width: 576px) {
        .block.bookingProcess .block_content .booking-pages .booking-page {
            padding: 0.2rem;
        }
    }
</style>
